import React, { Component } from "react";
import { postRequest } from "../../../../utils/request";
import Form from "./Form";
import { apiUrl } from "../../../../utils/apiUrl";
import { toast } from "../../../../utils/helpers";
import Loader from "../../../general/Loader";
import Modal from "../../../general/Modal";

class EditInscripcion extends Component {
    state = {
        errors: {},
        showDelete: false,
    };
    editUser = async event => {
        event.preventDefault();

        this.setState({saving: true});

        const data = new FormData(event.target);

        const response = await postRequest(apiUrl(`academico/inscripciones-cocurriculares/${this.props.inscripcion.id}`), data);

        if (response.success) {
            this.props.getInscripciones();
            this.props.toggle();
            toast("Inscripción actualizada.");
        }

        if (response.code === 422) {
            this.setState({ errors: response.data.message, saving: false });
        }
    };
    deleteInscripcion = async (inscripcion) => {
        this.setState({saving: true});

        const response = await postRequest(apiUrl(`academico/inscripciones-cocurriculares/${inscripcion}`), {}, 'delete');

        if (response.success) {
            this.props.getInscripciones();
            this.props.toggle();
            this.setState({saving: false});
            toast("Inscripción borrada.");
            return;
        } else {
            this.setState({errors: response.data.message, saving: false})
            toast(response.data, "error");
        }
    };
    render() {
        const { errors, saving, showDelete } = this.state;
        const { toggle, inscripcion } = this.props;
        return (
            <>
                <form method='post' onSubmit={this.editUser}>
                    <input type='hidden' name='_method' value='patch' />
                    <div className='popup__header'>Editar Inscripción</div>
                    <div className='popup__body'>
                        <Form
                            editar
                            estudiantes={this.props.estudiantes}
                            becas={this.props.becas}
                            clases={this.props.clases}
                            inscripcion={inscripcion}
                            errors={errors}
                        />
                    </div>
                    <div className='popup__footer'>
                        {!saving && (
                            <button
                                type='button'
                                className='btn float-left'
                                onClick={e => this.setState({showDelete: true})}>
                                <i className='fas fa-trash-alt'></i>
                            </button>
                        )}
                        <button
                            type='button'
                            onClick={toggle}
                            className='btn btn-plain'>
                            Cancelar
                        </button>
                        {saving && <Loader type="small"/>}
                        {!saving && (
                            <button type='submit' className='btn btn-primary'>
                                Guardar
                            </button>
                        )}
                    </div>
                </form>
                <Modal
                    title='Borrar Inscripción'
                    show={showDelete}
                    callback={() => this.deleteInscripcion(inscripcion.id)}
                    acceptText="Borrar"
                    toggle={() => this.setState(prev => ({showDelete: !prev.showDelete}))}>
                    ¿Seguro que deseas borrar la inscripcion de {inscripcion.contacto?.nombre}?
                </Modal>
            </>
        );
    }
}

export default EditInscripcion;
